export default __webpack_public_path__ + "saved.0bd175b5.png";